import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import UserForm from "./UserForm";
import TaxPayerUser, { newTaxPayerUser } from "../../models/tax-payer-user";

interface UserUpdateModalProps {
  show: boolean;
  user?: TaxPayerUser;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const UserUpdateModal: React.FC<UserUpdateModalProps> = ({
  show,
  user,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialUser, setInitialUser] = useState<TaxPayerUser>(
    user ? user : newTaxPayerUser()
  );

  const modalTitle = user
    ? `Editar usuario: ${user.email}`
    : `Crear usuario nuevo`;

  const onClose = () => {
    setInitialErrors({});
    setInitialUser(newTaxPayerUser());
    onCancel();
  };

  useEffect(() => {
    setInitialUser(user ? user : newTaxPayerUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <UserForm
            initialUser={initialUser}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default UserUpdateModal;
